import type { ReactNode } from "react";
import { Box } from "@mui/material";

import { authConfig } from "@/config/auth-config";

export const MarketingFrame = ({
  children,
  fullHeight = false,
  clipOverflow = false,
}: {
  children: ReactNode;
  fullHeight?: boolean;
  /** Preserve sticky descendants while still clipping the rounded frame. */
  clipOverflow?: boolean;
}) => (
  <Box
    sx={{
      m: { xs: 1, md: 2 },
      border: "1px solid hsl(var(--border))",
      borderRadius: 2,
      overflow: clipOverflow ? "clip" : "hidden",
      backgroundColor: "hsl(var(--background))",
      ...(fullHeight && {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }),
    }}
  >
    {children}
  </Box>
);

export const MarketingEyebrow = ({ children }: { children: ReactNode }) => (
  <Box
    component="span"
    sx={{
      display: "inline-block",
      color: "primary.main",
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      fontWeight: 900,
      letterSpacing: 1.4,
      textTransform: "uppercase",
    }}
  >
    {children}
  </Box>
);

export const marketingLoginHref = (destination: string) =>
  authConfig.loginUrlForRedirect(destination);
